var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.scanType === 'activityProduct')?_c('ProductDetail',{attrs:{"infoObj":_vm.infoObj}}):_c('UploadDetail',{attrs:{"infoObj":_vm.infoObj}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }